import axios from 'axios';
import { get } from './api';

export const fetchUserCountry = () =>
  axios.get('https://ipinfo.io/ip')
    .then(res => get('api/country/' + res.data))
    .then(countryRes => countryRes.country);
